import { Directive, Input, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';
import { UserService } from '../services/user.service';
import { map } from 'rxjs';

@Directive({
    selector: '[appMatchPassword]',
    providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => MatchPasswordDirective), multi: true }],
    standalone: false
})
export class MatchPasswordDirective implements Validator {
  @Input('appMatchPassword') matchPassword: string[] = [];

  constructor(private userService: UserService) {
  }

  isPasswordsMatched(password: string, confirmPassword: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.get(password);
      const matchingControl = formGroup.get(confirmPassword);
      if (!matchingControl?.value || !matchingControl?.dirty) {
        return null;
      }

      if (!control || !matchingControl) {
        return null;
      }

      // return if another validator has already found an error on the matchingControl
      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        return null;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ misMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
      return null;
    }
  }

  validate(formGroup: FormGroup): ValidationErrors | null {
    return this.isPasswordsMatched(this.matchPassword[0], this.matchPassword[1])(formGroup);
  }
}
